export default __webpack_public_path__ + "static/media/sample-icon.f1444254.svg";